import axios from "axios";
import { DefaultSuccess, IGetIMUserInfoRes } from "./types";
import { TOKEN_KEY } from "@/config";

export async function getIMUserInfo(
  userId: string
): Promise<DefaultSuccess<IGetIMUserInfoRes>> {
  const res = await axios.post(
    `${process.env.VITE_BACKEND_URL}/api/auth/im/user-verify`,
    {
      userId,
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem(TOKEN_KEY)}`,
      },
    }
  );
  console.log("getIMUserInfo res", res);
  if (res.data.code === 200) {
    return res.data;
  }
  throw res.data;
}
